
import Vue from 'vue/dist/vue.common.js';
import Hello from '../vue-components/Hello.vue';

export default class StyleGuide {
    constructor() {
    }

    init(eleID, initData) {
        new Vue({
            el: eleID,
            components: {
                Hello
            },
            data: {
            },
            methods: {
            },
            filters: {
            }
        });
    }
}